import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const OrganizationsPage = lazy(() =>
  import('../../pages/admin/organizations/OrganizationsPage').then((m) => ({
    default: m.OrganizationsPage,
  })),
);

export const Route = createFileRoute('/admin/organizations')({
  component: () => (
    <Suspense
      fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%', transform: 'translateX(-50%)' }} />}
    >
      <OrganizationsPage />
    </Suspense>
  ),
});
